import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Wallet, TrendingUp, Clock, ShoppingBag } from 'lucide-react';

const naira = (n) => `₦${Number(n || 0).toLocaleString()}`;

const KpiCards = ({ portfolio, kpis }) => {
  const cards = [
    {
      key: 'total_invested',
      label: 'Portfolio value',
      value: naira(portfolio.total_invested),
      sub: `+${naira(portfolio.total_return_expected)} projected`,
      icon: Wallet,
      color: 'from-green-500 to-emerald-600',
    },
    {
      key: 'active',
      label: 'Active investments',
      value: portfolio.active,
      sub: portfolio.matured ? `${portfolio.matured} matured` : 'Track maturity below',
      icon: TrendingUp,
      color: 'from-blue-500 to-indigo-600',
    },
    {
      key: 'pending',
      label: 'Pending payment',
      value: portfolio.pending,
      sub: portfolio.pending ? 'Complete transfer to activate' : 'All clear',
      icon: Clock,
      color: 'from-amber-500 to-orange-600',
    },
    {
      key: 'orders',
      label: 'Recent orders',
      value: kpis.recent_orders,
      sub: 'Last 30 days',
      icon: ShoppingBag,
      color: 'from-purple-500 to-pink-600',
    },
  ];

  return (
    <div
      className="grid grid-cols-2 lg:grid-cols-4 gap-3"
      data-testid="dashboard-kpi-cards"
    >
      {cards.map((c) => (
        <Card key={c.key} className="overflow-hidden card-hover-lift">
          <CardContent className="p-4">
            <div className="flex items-start justify-between mb-2">
              <div className={`w-9 h-9 rounded-lg bg-gradient-to-br ${c.color} flex items-center justify-center text-white`}>
                <c.icon className="h-4 w-4" aria-hidden="true" />
              </div>
            </div>
            <p className="text-xs uppercase tracking-wide text-gray-500">{c.label}</p>
            <p className="text-2xl font-bold text-gray-900 mt-0.5 truncate" data-testid={`kpi-${c.key}`}>
              {c.value}
            </p>
            <p className="text-[11px] text-gray-500 mt-1 truncate">{c.sub}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default KpiCards;
